import { Modal, type ModalProps } from 'antd';
import { useRef } from 'react';
import { wrapDraggableModalNode } from './draggable-modal';

export interface DraggableModalProps extends ModalProps {
  /** 是否允许通过标题栏拖动，默认启用。 */
  draggable?: boolean;
}

/** 统一的管理端对话框：保留 AntD 行为，并为标题栏增加独立、可复位的拖动能力。 */
export function DraggableModal({
  draggable = true,
  modalRender,
  open,
  title,
  closable,
  ...rest
}: DraggableModalProps) {
  const previousOpenRef = useRef(false);
  const openCycleRef = useRef(0);

  if (open && !previousOpenRef.current) {
    openCycleRef.current += 1;
  }
  previousOpenRef.current = Boolean(open);

  const hasTitle = title !== null && title !== undefined;
  const canDrag = draggable && (hasTitle || closable !== false);

  return (
    <Modal
      {...rest}
      open={open}
      title={title}
      closable={closable}
      modalRender={(node) =>
        wrapDraggableModalNode(modalRender ? modalRender(node) : node, {
          draggable: canDrag,
          resetKey: openCycleRef.current,
        })
      }
    />
  );
}
